{
  "stage": {
    "junior_section": "Junior section",
    "junior_circuit": "Junior Circuit",
    "county_squad": "County squad",
    "national_squad": "National squad",
    "elite_amateur": "Elite amateur circuit",
    "mid_amateur": "Mid-amateur golf",
    "senior_amateur": "Senior amateur golf",
    "college": "College golf",
    "regional_pro": "Regional Pro Series",
    "tour_school": "Tour School",
    "second_tier": "Horizon Tour and Horizon Women's Tour",
    "main_tour": "Atlantic Tour and Atlantic Women's Tour",
    "senior_tour": "Evergreen Tour",
    "club_pro": "Club-professional route and Club Pro Tour",
    "long_drive": "Long Drive Series",
    "adaptive": "Adaptive Golf Series",
    "homegrown_league": "Homegrown League"
  }
}
